import InputField from "../../../../Forms/Input/InputField";

interface Props {
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
}

const TextFilterField: React.FC<Props> = ({ name, label, value, onChange }) => (
  <InputField
    label={label}
    name={name}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder={`Ingrese ${label.toLowerCase()}`}
    type="text"
    iconKey="edit"
  />
);

export default TextFilterField;
